import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Top-bar serial lookup: type part of a serial → jump to its serialization run (WO, customer, faceplate).
export const SerialSearchBox = () => {
  const { api } = useAuth();
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return; }
    const t = setTimeout(() => api().get('/serial-search', { params: { q } }).then(r => { setRows(r.data); setOpen(true); }).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h);
  }, []);
  const go = (r) => { setOpen(false); setQ(''); nav(`/serials/${encodeURIComponent(r.serial)}`); };
  return (
    <div ref={box} className="relative hidden md:block w-72" data-testid="serial-search">
      <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-slate-400" />
      <input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => rows.length && setOpen(true)}
        onKeyDown={(e) => { if (e.key === 'Enter' && rows[0]) go(rows[0]); if (e.key === 'Escape') setOpen(false); }}
        placeholder="Search serial #" className="w-full h-9 pl-8 pr-2 text-sm border border-slate-200 rounded-sm focus:outline-none focus:border-slate-400 mono" data-testid="serial-search-input" />
      {open && q.trim().length >= 2 && (
        <div className="absolute z-50 mt-1 w-[26rem] bg-white border border-slate-200 rounded-sm shadow-lg max-h-80 overflow-y-auto" data-testid="serial-search-results">
          {rows.length === 0 ? <div className="px-3 py-2 text-xs text-slate-400" data-testid="serial-search-empty">No serials match "{q}"</div> : rows.map((r, i) => (
            <button key={r.serial} type="button" onClick={() => go(r)} className="w-full text-left px-3 py-2 hover:bg-slate-50 border-b border-slate-100 last:border-0" data-testid={`serial-search-result-${i}`}>
              <div className="flex justify-between gap-2"><span className="mono text-sm font-semibold">{r.serial}</span><span className="text-[10px] text-slate-500">{r.run_status}{r.status === 'Void' ? ' · void' : ''}</span></div>
              <div className="text-xs text-slate-500 truncate">{r.product_name || r.product_key} · {r.source_number || 'Manual'}{r.customer ? ` · ${r.customer}` : ''}{r.template_name ? ` · ${r.template_name}` : ''}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SerialSearchBox;
